var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBeakerE(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 850 850",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        stroke-miterlimit: 10;\n      }\n\n      .cls-1, .cls-2 {\n        fill: none;\n        stroke: #668ba6;\n        stroke-linecap: round;\n        stroke-width: 7px;\n      }\n\n      .cls-3 {\n        fill-opacity: .2;\n      }\n\n      .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9, .cls-10 {\n        stroke-width: 0px;\n      }\n\n      .cls-3, .cls-9 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        stroke-linejoin: round;\n      }\n\n      .cls-4 {\n        fill: #003e6b;\n      }\n\n      .cls-5 {\n        fill: #33bef2;\n      }\n\n      .cls-6 {\n        fill: #000;\n      }\n\n      .cls-7 {\n        fill: #66cef5;\n      }\n\n      .cls-8 {\n        fill: #668ba6;\n      }\n\n      .cls-10 {\n        fill: #d9ecf6;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bg"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: -20,
    y: -20,
    width: 895.5,
    height: 895.5
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "beaker_E",
    "data-name": "beaker E"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M695.7,150.4c-2.5,5-8.2,7.6-13.7,6.1l-7.2-2c-20.2,8.8-22,16.3-22.7,42.7v537.9c0,12.7-10.3,23-23.1,23l-445.3.2c-12.8,0-24.3-9.4-24.3-22.1V129.4c0-9.2-1.5-17.4-6.7-25.2-2.7-5.8,1.6-12.5,8-12.5h453.1c29,0,56.8,11.9,76.8,32.8,7.3,6.6,9.3,17.2,5,25.9h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M190.5,449.5h249.5c12.2-.1,22.1-7.4,22.1-16.4v-82.7c-104.7-2.7-160-14-293.7-14v96.7c0,9,9.9,16.3,22.1,16.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M168.4,360.5v366.6c0,9,9.9,16.2,22.1,16.2h433.8c12.2-.1,22.3-7.7,22.3-16.6v-388.3c0-1.6-.1-3.9,0-5.5-102.6.7-335.1,27.7-478.2,27.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M278.4,103c0,2.1-2.1,3.8-4.6,3.8h-96.2c-2.5,0-4.6-1.7-4.6-3.8s2.1-3.8,4.6-3.8h96.2c2.5,0,4.6,1.7,4.6,3.8ZM533.1,99.3h-220c-5.8,0-10.5,1.7-10.5,3.8s4.7,3.8,10.5,3.8h220c5.8,0,10.5-1.7,10.5-3.8s-4.7-3.8-10.5-3.8ZM252.5,134h-39.2c-4.8,0-8.6,6.8-8.6,15.3v563.2c0,11,5.1,20,11.3,20h33.8c6.3,0,11.3-8.9,11.3-20V149.2c0-8.4-3.9-15.3-8.6-15.3h0Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 209.2,
    y1: 340.6,
    x2: 183.8,
    y2: 340.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 209.2,
    y1: 440.7,
    x2: 183.8,
    y2: 440.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 209.2,
    y1: 540.9,
    x2: 183.8,
    y2: 540.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 209.2,
    y1: 641,
    x2: 183.8,
    y2: 641
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 225.6,
    y1: 390.7,
    x2: 183.8,
    y2: 390.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 225.6,
    y1: 490.8,
    x2: 183.8,
    y2: 490.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 225.6,
    y1: 591,
    x2: 183.8,
    y2: 591
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "225.6 290.5 183.8 290.5 183.8 691.1 225.6 691.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M239.8,301.6c0-4.9,2.2-7.8,8-10.5,3.9-1.8,5.2-3.1,5.2-5.3s-1.1-3.1-3.6-3.1-3.8,1.2-3.8,3.9v.7h-5.3v-1.2c0-5.4,3.2-8.2,9.2-8.2s9.2,2.9,9.2,7.8-2.2,7-7.9,9.6c-3.5,1.6-4.8,2.5-5.2,4.1h13.1v4.8h-18.7v-2.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M262.6,297.1h5.4c.1,1.9,1.5,2.9,3.9,2.9s4.1-1.4,4.1-4.1-1.3-4.1-3.8-4.1-2.9.6-3.8,1.6h-4.9l1-14.9h16.1v4.8h-11.4l-.3,5.4c1.4-1.1,3-1.5,5-1.5,5.1,0,7.9,3,7.9,8.6s-3.2,9-9.6,9-9.3-2.6-9.3-7.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M285.2,296v-9.4c0-5.7,3.2-8.7,9.4-8.7s9.4,3,9.4,8.7v9.4c0,5.7-3.2,8.7-9.4,8.7s-9.4-3-9.4-8.7ZM298.3,295.8v-8.9c0-2.9-1.1-4.2-3.7-4.2s-3.7,1.2-3.7,4.2v8.9c0,2.9,1.1,4.2,3.7,4.2s3.7-1.2,3.7-4.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M317.5,284.5h4.8v2.4c1.6-2,3.3-2.9,5.8-2.9s4.3,1,5.3,2.8c1.5-2,3.3-2.8,5.7-2.8,4,0,6.3,2.4,6.3,6.8v13.5h-5.6v-12.9c0-1.8-.8-2.5-2.1-2.5s-2.4.8-3.3,2.7v12.7h-5.6v-12.9c0-1.8-.8-2.5-2.2-2.5s-2.4.8-3.3,2.7v12.7h-5.6v-19.8h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M350.4,278.5h5.7v20.9h10.9v5h-16.6v-25.8Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 300,
    y: 406.8,
    width: 250,
    height: 224.9,
    rx: 14.4,
    ry: 14.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M407.2,487.8h37.9v10.5s-25.7,0-25.7,0v11.5h21.6v10.4h-21.6v12.5h26.5v10.5h-38.7v-55.4c0,0,0,0,0,0Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeakerE);
export default __webpack_public_path__ + "static/media/beaker_e.a81328291ab2e472b40fb0436210a29f.svg";
export { ForwardRef as ReactComponent };